import { UpdateCustomComponentInput } from '@/utils/api'

export const storeKey = 'component-library'

export interface CustomComponentEnhanced<T extends {}>
  extends Omit<UpdateCustomComponentInput, 'settings'> {
  settings?: Partial<T> | null
}
